import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import styled from "styled-components";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import DeleteButton from "./DeleteButtonWithMutation";
import { EditPost } from "../store";

export default class Row extends Component {
  static propTypes = {
    id: PropTypes.number,
    editing: PropTypes.bool,
    content: PropTypes.string,
    channel: PropTypes.object,
    sentBy: PropTypes.object,
    dateForPost: PropTypes.object,
    dateCreated: PropTypes.object,
    companyChannelHandler: PropTypes.object,
    imageUrl: PropTypes.string,
    specificType: PropTypes.object
  };
  static defaultProps = {};

  render() {
    const props = this.props;
    return (
      <Wrapper editing={props.editing}>
        <Avatar
          image={props.companyChannelHandler.displayPicture}
          channel={props.channel.name}
        />
        <RightColumn>
          <MetaScehdule>
            <Span>
              <IconClock name="clock-gray" width={10} height={10} />
              scheduled by
              <AgentName>{props.sentBy.displayName}</AgentName>
            </Span>
          </MetaScehdule>
          <ChannelName>@{props.companyChannelHandler.displayName}</ChannelName>
          <Summary>{props.content}</Summary>
        </RightColumn>
        <ActionColumn>
          <IconEdit name="edit" onClick={this.onEditClick} />
          <DeleteButton id={props.id} />
        </ActionColumn>
        <Metadata>
          <Span>
            {moment().isBefore(props.dateForPost)
              ? "Will be posted "
              : "Has been posted "}
          </Span>
          <Time>{props.dateForPost.fromNow()}</Time>
        </Metadata>
      </Wrapper>
    );
  }

  onEditClick = () => {
    const {
      id,
      content,
      channel,
      companyChannelHandler,
      dateForPost,
      imageUrl,
      specificType
    } = this.props;
    EditPost(
      id,
      content,
      {
        channelId: channel.id,
        companyChannelHandler: companyChannelHandler.id,
        specificType: specificType.id
      },
      dateForPost,
      imageUrl
    );
  };
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  align-content: space-between;
  height: 120px;
  padding-left: 10px;
  cursor: pointer;
  transition: 0.3s;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  &:hover {
    background-color: ${props => props.theme.moduleBackground};
  }
  ${props => props.color && `background-color: ${props.theme[props.color]};`};
  ${props =>
    props.editing && `background-color: ${props.theme.moduleBackground};`};
`;
const RightColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px;
  min-width: 460px;
  margin-right: auto;
  margin-left: 6px;
  overflow: hidden;
  justify-content: flex-start;
`;
const ActionColumn = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin-right: 20px;
  margin-left: 6px;
  overflow: hidden;
  justify-content: flex-end;
`;
const ChannelName = styled.div`
  font-size: 0.9rem;
  color: ${props => props.theme.uiText};
  font-weight: bold;
  padding-top: 5px;
  padding-bottom: 10px;
`;
const Summary = styled.div`
  font-size: 1rem;
  overflow: hidden;
  height: 3rem;
  word-break: break-word;
`;
const Metadata = styled.div`
  position: absolute;
  top: 7px;
  right: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const MetaScehdule = styled.div`
  position: absolute;
  top: 7px;
  left: 77px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const Time = styled.div`
  margin-right: 6px;
  font-size: 0.7rem;
  color: #5296ee;
`;
const Span = styled.span`
  font-size: 0.7rem;
  color: #6c7379;
  margin-right: 3px;
`;
const AgentName = styled.span`
  color: #338dca;
  margin-left: 3px;
`;
const IconEdit = styled(Icon)`
  margin-left: 10px;
  margin-right: 18px;
`;
const IconClock = styled(Icon)`
  margin-top: 2px;
  margin-right: 3px;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/list/Row.js